import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Modal } from "../Modal/Modal";
import { Heading } from "../Heading/Heading";
import { Button } from "../Button/Button";
import { InputField } from "../InputField/InputField";
import { useState } from "react";
import { trackEvent } from "../../../helpers/analytics-helpers";

export const DemoModal = ({ isModalOpen, closeModal }) => {
  const { t } = useTranslation();

  const [name, setName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [nameErrorMessage, setNameErrorMessage] = useState("");
  const [emailErrorMessage, seEmailErrorMessage] = useState("");
  const [telegram, setTelegram] = useState("");

  const handleSubmit = () => {
    setNameErrorMessage();
    seEmailErrorMessage();

    let error = false;
    if (name.trim().length === 0) {
      setNameErrorMessage(t("demo.errorMessageRequired"));
      error = true;
    }
    if (phoneNumber.trim().length === 0) {
      seEmailErrorMessage(t("demo.errorMessageRequired"));
      error = true;
    }

    if (error) {
      return;
    } else {
      trackEvent("demo-request", { name, phoneNumber, telegram });
      closeModal();
    }
  };

  return (
    <Modal isOpen={isModalOpen} onClose={closeModal}>
      <Heading size={2} text={t("demo.title")} marginBottom={1} />
      <InputField
        label={t("demo.nameLabel")}
        placeholder={t("demo.namePlaceholder")}
        value={name}
        onChange={setName}
        required={true}
        errormessage={nameErrorMessage}
      />
      <InputField
        label={t("demo.phoneLabel")}
        placeholder={"+7"}
        value={phoneNumber}
        onChange={setPhoneNumber}
        required={true}
        errormessage={emailErrorMessage}
        type="tel"
      />
      <InputField
        label={t("Telegram")}
        placeholder={"@username"}
        value={telegram}
        onChange={setTelegram}
      />
      <ButtonsContainer>
        <Button
          onClick={() => {
            handleSubmit();
          }}
          text={t("demo.submitButton")}
        />
      </ButtonsContainer>
    </Modal>
  );
};

const ButtonsContainer = styled.div`
  display: flex;
  gap: 0.5rem;
`;
